import { cloudApiClient } from '../clientSideCloudApiService';

export const SANCTUM_CSRF_COOKIE_ENDPOINT = 'sanctum/csrf-cookie';
export const clientSideSanctumInit = async () => {
  await cloudApiClient.get(SANCTUM_CSRF_COOKIE_ENDPOINT);
};
